export const categories = [
  {
    id: "VpEIkZNRjzSuefFu6ke8",
    categoryName: "Weight Loss",
    subcategories: [
      { name: "Belly Fat", id: "pKzRUUaBZ46cHIklYYBk" },
      { name: "Whey Protein Isolate", id: "dsdd" },
      { name: "Protein Bars", id: "kcndkd" },
      { name: "Weight Gainers", id: "pooee" },
    ],
  },
  {
    id: "c1",
    categoryName: "Proteins",
    subcategories: [
      { name: "Whey Protein", id: "asasa" },
      { name: "Whey Protein Isolate", id: "dsdd" },
      { name: "Protein Bars", id: "kcndkd" },
      { name: "Weight Gainers", id: "pooee" },
    ],
  },
  {
    id: "c2",
    categoryName: "Build Muscles",
    subcategories: [
      { name: "Creatine", id: "plpsd" },
      { name: "Amino Acids", id: "ojoas" },
      { name: "Glutamine", id: "pokd" },
      { name: "Testoaterone Support", id: "wqwqw" },
    ],
  },
  {
    id: "c3",
    categoryName: "Workout Support",
    subcategories: [
      { name: "Pre-Workout", id: "poew" },
      { name: "During Workout", id: "asas" },
      { name: "Post Workout Recovery", id: "asass" },
    ],
  },
  //{ id: "mn8Ja1yF7AE9es2QZsrp", categoryName: "Shop", subcategories:[{name:"Biceps Growth",id:"bb5f3006d7"}] },
];

//For ProductType
export const productTypes = [
  { id: "pt1", name: "Latest" },
  { id: "pt2", name: "Best Sale" },
  { id: "pt3", name: "Top Rated" },
  { id: "pt4", name: "On Sale" },
];

//For shop
export const shopcategories = [
  {
    id: "mn8Ja1yF7AE9es2QZsrp",
    categoryName: "Shop",
    subcategories: [
      { name: "Belly Fat", id: "pKzRUUaBZ46cHIklYYBk" },
      { name: "Whey Protein Isolate", id: "dsdd" },
      { name: "Protein Bars", id: "kcndkd" },
      { name: "Weight Gainers", id: "pooee" },
    ],
  },
];

export const carouselData = [
  {
    id: "gjjh",
    imgUrl:
      "https://images.squarespace-cdn.com/content/v1/59f0e161edaed84e6822a957/1571628555108-DY51TDBAHIVET3UUTMUG/ke17ZwdGBToddI8pDm48kGDIyjzonpL-SIH_-rfC9dEUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcZ8YuFwU-vI3pzKyV0SD7SwNRGg-RLS7V_9PYgJlWdsL2jExSAJ05vHpoYK-Qi6s6/Fitness-banner-1.jpg",
    imgTitle: "Slider Image title",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
  {
    id: "dsaf",
    imgUrl: "https://powerbreakfitness.in/images/banner2.jpg",
    imgTitle: "Slider Image title",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
  {
    id: "dsafsd",
    imgUrl:
      "https://www.profitfitness.org/wp-content/uploads/2019/08/banner-pro.jpg",
    imgTitle: "Slider Image title",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
];

export const productData = [
  {
    // id: "dfasf",
    id: "c62ac0d2204051f7277cf92ec0857a79",
    // productImgUrl: "https://cdn.healthxp.in/wp-content/uploads/2017/07/100-Whey_Peanut-Butter-FREE.jpg",
    productTitle:
      "ON (Optimum Nutrition) Gold Standard 100% Whey Protein 5Lbs + HealthXP Multivitamin 60 Tablets ( Combo offer )",
    productDesc: "Some short product description goes here...",
    variable: true,
    categoryId: "2t5lTHLgjc1CvAHLcnDs",
    categoryName: "Muscle Building",
    subcategoryId: "rob0HqfP7GvQBuOzGdfff5af",
    subcategoryName: "Thigh Muscles",
    productTypeId: "pt1",
    rating: 4,
    reviewCount: 256,
    brand: "Optimum Nutrition",
    brandId: "rxKfxp9oEhodXgc0tfctbedd",
    variants: [
      {
        attributes: {
          "0b69b093d7b8cdabab64719d7016f6c1": {
            attribute: "size",
            id: "0b69b093d7b8cdabab64719d7016f6c1",
            name: "S",
            value: "S",
          },

          c2d1a40fe6a9: {
            attribute: "color",
            id: "c2d1a40fe6a9",
            name: "Orange",
            value: "Orange",
          },
        },
        previewImages: [
          "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F3a17Ticket.png?alt=media&token=dccce826-5e1f-4778-bba1-12cac9cedcf7",
          "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F82f8Screenshot%202021-07-15%20at%2011.45.44%20AM.png?alt=media&token=455a16bc-1394-4a62-8a61-9cf5e547dc70",
          "https://firebasestorage.googleapis.com/v0/b/k5-dev.appspot.com/o/2t5lTHLgjc1CvAHLcnDs%2Frob0HqfP7GvQBuOzGdfff5af%2F2474Screenshot%202021-07-28%20at%2010.02.43%20PM.png?alt=media&token=b493e236-d2a8-4026-aa8b-6fef45397562",
        ],
        productDesc: "Variant Desc",
        productTitle: "Variant 1",
        regularPrice: 2,
        salePrice: 2,
        stock: 2,
        variantId: "0b69b093d7b8cdabab64719d7016f6c1OrangeSc2d1a40fe6a9",
        weight: 2,
      },
    ],
    // variants: [
    //   //option, color, button
    //   {
    //     id: "dfasf",
    //     variantId: "dfasf_v1-1",
    //     productTitle:
    //       "ON (Optimum Nutrition) Gold Standard 100% Whey Protein 5Lbs + HealthXP Multivitamin 60 Tablets ( Combo offer )",
    //     productDesc: "Some short product description goes here...",
    //     enabled: true,
    //     attributes: {
    //       flavourId: {
    //         attribute:"flavour",
    //         name: "Chocolate Malt",
    //         type: "select",
    //         value: "Chocolate Malt",
    //       },
    //       sizeId: {
    //         attribute:"size",
    //         name: "5lbs",
    //         type: "select",
    //         value: "5lbs",
    //       },
    //     },
    //     regularPrice: 7699,
    //     salePrice: 4999,
    //     stock: 20,
    //     previewImages: [
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/100-Whey_Peanut-Butter-FREE.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-1.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-10.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-2.jpg",
    //     ],
    //   },

    //   {
    //     id: "dfasf",
    //     variantId: "dfasf_v1-2",
    //     productTitle:
    //       "ON (Optimum Nutrition) Gold Standard 100% Whey Protein 5Lbs + HealthXP Multivitamin 60 Tablets ( Combo offer )",
    //     productDesc: "Some short product description goes here...",
    //     enabled: true,
    //     attributes: {
    //       flavourId: {
    //         attribute:"flavour",
    //         name: "Delicious Strawberry",
    //         type: "select",
    //         value: "Delicious Strawberry",
    //       },
    //       sizeId: {
    //         attribute:"size",
    //         name: "1lbs",
    //         type: "select",
    //         value: "1lbs",
    //       },
    //     },
    //     regularPrice: 1999,
    //     salePrice: 1499,
    //     stock: 20,
    //     previewImages: [
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/ON-whey-1lbs.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Optimum-Nutrition-Gold-Standard-100-Whey-Protein-1Lb_3.jpg",
    //     ],
    //   },
    //   {
    //     id: "dfasf",
    //     variantId: "dfasf_v1-3",
    //     productTitle:
    //       "ON (Optimum Nutrition) Gold Standard 100% Whey Protein 10lbs",
    //     productDesc: "Some short product description goes here...",
    //     enabled: true,
    //     attributes: {
    //       flavourId: {
    //         attribute:"flavour",
    //         name: "Delicious Strawberry",
    //         type: "select",
    //         value: "Delicious Strawberry",
    //       },
    //       sizeId: {
    //         attribute:"size",
    //         name: "10lbs",
    //         type: "select",
    //         value: "10lbs",
    //       },
    //     },
    //     regularPrice: 9999,
    //     salePrice: 8599,
    //     stock: 0,
    //     previewImages: [
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/ON-whey-1lbs.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Optimum-Nutrition-Gold-Standard-100-Whey-Protein-1Lb_3.jpg",
    //     ],
    //   },
    //   //Test data
    //   {
    //     id: "dfasf",
    //     variantId: "dfasf_v1-4",
    //     productTitle:
    //       "ON (Optimum Nutrition) Gold Standard 100% Whey Protein 10lbs",
    //     productDesc: "Some short product description goes here...",
    //     enabled: true,
    //     attributes: {
    //       flavourId: {
    //         attribute:"flavour",
    //         name: "Caramel",
    //         type: "select",
    //         value: "Caramel",
    //       },
    //       sizeId: {
    //         attribute:"size",
    //         name: "4lbs",
    //         type: "select",
    //         value: "4lbs",
    //       },
    //     },
    //     regularPrice: 3499,
    //     salePrice: 2999,
    //     stock: 4,
    //     previewImages: [
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/02/ON-whey-1lbs.jpg",
    //       "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Optimum-Nutrition-Gold-Standard-100-Whey-Protein-1Lb_3.jpg",
    //     ],
    //   },
    // ],
  },

  /////////////////////

  {
    id: "ehwjh",
    productTitle:
      "Optimum Nutrition (ON) Instantized BCAA 5000 mg Powder – 380g, 40 Servings",
    productDesc: "Some short product description goes here...",
    salePrice: 3999,
    regularPrice: 4999,
    categoryId: "VpEIkZNRjzSuefFu6ke8",
    categoryName: "Weight Loss",
    subcategoryId: "yzNG4gO6h0IbMfy7LygH839e",
    subcategoryName: "Obesity",
    productTypeId: "pt3",
    brand: "Optimum Nutrition",
    brandId: "rxKfxp9oEhodXgc0tfctbedd",
    stock: 35,
    variable: false,
    variants: [],
    rating: 4,
    reviewCount: 256,
    weight: 300,
    previewImages: [
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2016/07/bright-commodityon1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_3.jpg",
    ],
  },
  {
    id: "gahj",
    productImgUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2020/09/Sporto-Fitness-PVC-40-Kg-Home-Gym-Set-Flate-Bench-370x370.jpg",
    productTitle:
      "Sporto Fitness PVC 20 Kg Home Gym Set with One 3 Ft Curl+ One 5 Ft Plain Rod and One Pair Dumbbell Rods Comes with Flate Bench",
    productDesc: "Some short product description goes here...",
    salePrice: 2999,
    regularPrice: 3499,
    categoryId: "c3",
    subcategoryId: "poew",
    productTypeId: "idoftoprated",
    brand: "Optimum Nutrition",
    brandId: "sdasdasdd",
    stock: 15,
    variable: false,
    previewImages: [
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2016/07/bright-commodityon1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_3.jpg",
    ],
  },
  {
    id: "287fjhj",
    productImgUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2019/07/Medtrix-Cervical-Spondylosis-Neck-Back-Pain-Support-Pillow-370x370.jpg",
    productTitle:
      "Medtrix Cervical Spondylosis Neck & Back Pain Support Pillow",
    productDesc: "Some short product description goes here...",
    salePrice: 430,
    regularPrice: 599,
    categoryId: "c4",
    subcategoryId: "poew",
    productTypeId: "idofonsale",
    brand: "Optimum Nutrition",
    brandId: "sdasdasdd",
    stock: 12,
    variable: false,
    previewImages: [
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2016/07/bright-commodityon1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_3.jpg",
    ],
  },
  {
    id: "287fjhjd",
    productImgUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2019/07/Medtrix-Cervical-Spondylosis-Neck-Back-Pain-Support-Pillow-370x370.jpg",
    productTitle:
      "Medtrix Cervical Spondylosis Neck & Back Pain Support Pillow",
    productDesc: "Some short product description goes here...",
    salePrice: 430,
    regularPrice: 599,
    categoryId: "c4",
    subcategoryId: "poew",
    productTypeId: "idofonsale",
    brand: "Optimum Nutrition",
    brandId: "sdasdasdd",
    stock: 16,
    variable: false,
    previewImages: [
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2016/07/bright-commodityon1.jpg",
      "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_3.jpg",
    ],
  },
];
//Ad Bannner

export const bannerData = [
  {
    id: "1",
    imgTitle: "Slider Image title",
    imgUrl:
      "https://image.made-in-china.com/208f0j00AatTyFmdkQks/%E8%B7%91%E6%AD%A5%E6%9C%BABANNER1.jpg",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
  {
    id: "2",
    imgTitle: "Slider Image title",
    imgUrl:
      "https://image.made-in-china.com/208f0j00AatTyFmdkQks/%E8%B7%91%E6%AD%A5%E6%9C%BABANNER1.jpg",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
];

export const navItems = [
  { url: "/", name: "Home" },
  { url: "/workouts", name: "Workouts" },
  { url: "/collection", name: "Brands" },
  { url: "/shop", name: "Shop", shop: true },
  { url: "/aboutUs", name: "About us" },
];

export const workoutPlans = [
  {
    id: "plan01",
    title: "Muscle building",
    categoryName: "Build Muscles",
    desc: "Its time to make some gains",
    workouts: [
      {
        id: "url1",
        url: "https://www.youtube.com/embed/rs3fBoxr0iI",
        title: "Youtube Title 6",
      },
      {
        id: "url2",
        url: "https://www.youtube.com/embed/oB56u_UG1w8",
        title: "Youtube Title 5",
      },
      {
        id: "url3",
        url: "https://www.youtube.com/embed/d8E3ocZg92w",
        title: "Youtube Title 4",
      },
      {
        id: "url4",
        url: "https://www.youtube.com/embed/jF0fMl84Il4",
        title: "Youtube Title 3",
      },
      {
        id: "url5",
        url: "https://www.youtube.com/embed/3uSSkYSxYHs",
        title: "Youtube Title 2",
      },
      {
        id: "url6",
        url: "https://www.youtube.com/embed/nV1FmPGELqA",
        title: "Youtube Title 1",
      },
    ],
  },
  {
    id: "plan02",
    title: "Weight Loss",
    desc: "Burn fat and get into your best-ever shape",
    categoryName: "Weight Loss",
    workouts: [
      {
        id: "url1",
        url: "https://www.youtube.com/embed/7fICF_O5esc",
        title: "Youtube Title 1",
      },
      {
        id: "url2",
        url: "https://www.youtube.com/embed/7KSNmziMqog",
        title: "Youtube Title 2",
      },
      {
        id: "url3",
        url: "https://www.youtube.com/embed/Dj0bk8TFWdY",
        title: "Youtube Title 3",
      },
      {
        id: "url4",
        url: "https://www.youtube.com/embed/6wREO0mfsiE",
        title: "Youtube Title 4",
      },
      {
        id: "url5",
        url: "https://www.youtube.com/embed/wXzveroBplo",
        title: "Youtube Title 5",
      },
      {
        id: "url6",
        url: "https://www.youtube.com/embed/Ci3na6ThUJc",
        title: "Youtube Title 6",
      },
    ],
  },
];

export const collections = [
  {
    id: "c1",
    imageUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2018/11/optimum-nutrition.png",
    brand: "Optimum Nutrition",
    brandId: "b1",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
  {
    id: "c2",
    imageUrl: "https://cdn.healthxp.in/wp-content/uploads/2018/11/isopure.png",
    brand: "Iso Pure",
    brandId: "zcxccx",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
  {
    id: "c3",
    imageUrl: "https://cdn.healthxp.in/wp-content/uploads/2018/11/ritebite.png",
    brand: "Rite Bite",
    brandId: "vmvcv",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
  {
    id: "c4",
    imageUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2018/11/optimum-nutrition.png",
    brand: "Nike",
    brandId: "b2",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
  {
    id: "c5",
    imageUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2020/08/nutrabox_2.jpg",
    brand: "Nutra Box",
    brandId: "mxdcdc",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
  {
    id: "c6",
    imageUrl:
      "https://cdn.healthxp.in/wp-content/uploads/2018/11/bpi-sports.png",
    brand: "BPI Sports",
    brandId: "lsdsdsd",
    desc: "When writing your brand statement, what your aiming for is convincing your target customers that your brand is exactly what they’re looking for",
  },
];

export const brands = [
  { id: "b1", name: "Optimum Nutrition", imgUrl: "" },
  { id: "b2", name: "Nike", imgUrl: "" },
];

export const attributes = [
  {
    id: "a1",
    name: "Flavor",
    values: ["Vanilla", "Chocololate", "Strawberry", "Rose"],
  },
  {
    id: "a2",
    name: "Size",
    values: ["M", "S", "L", "XL", "XXL"],
  },
  {
    id: "a3",
    name: "Quantity",
    values: ["250g", "500g", "1kg", "2kg", "5kg"],
  },
];

export const searchKeys = [
  "Optimum Nutrition Whey Protein",
  "Isopure whey protein",
  "Protien Bar stick",
];
export const images = [
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/100-Whey_Peanut-Butter-FREE.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-1.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-10.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Gold-Standard-Whey-Protein-5Lb-2.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/ON-whey-1lbs.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Optimum-Nutrition-Gold-Standard-100-Whey-Protein-1Lb_3.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/ON-whey-1lbs.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/07/ON-Optimum-Nutrition-Gold-Standard-100-Whey-Protein-1Lb_3.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_1.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/prd_217923_c_xxl.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2016/07/bright-commodityon1.jpg",
  "https://cdn.healthxp.in/wp-content/uploads/2017/02/Optimum-Nutrition-ON-Instantized-BCAA-5000-mg-Powder-%E2%80%93-380-g-By-Bright-Commodities_3.jpg",
];
export const clients = [
  {
    id: "gjjh",
    imgUrl:
      "https://image.freepik.com/free-vector/luxury-letter-e-logo-design_1017-8903.jpg",
    imgTitle: "Slider Image title",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
  {
    id: "dsaf",
    imgUrl:
      "https://pbs.twimg.com/profile_images/1092752196314091520/mzWO51Da_400x400.jpg",
    imgTitle: "Slider Image title",
    redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  },
  // {
  //   id: "dsafsd",
  //   imgUrl: "https://image.freepik.com/free-vector/3d-box-logo_1103-876.jpg",
  //   imgTitle: "Slider Image title",
  //   redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  // },
  // {
  //   id: "defef",
  //   imgUrl: "https://image.freepik.com/free-vector/blue-tech-logo_1103-822.jpg",
  //   imgTitle: "Slider Image title",
  //   redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  // },
  // {
  //   id: "vvvve",
  //   imgUrl:
  //     "https://image.freepik.com/free-vector/colors-curl-logo-template_23-2147536125.jpg",
  //   imgTitle: "Slider Image title",
  //   redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  // },
  // {
  //   id: "dsaf22e2esd",
  //   imgUrl:
  //     "https://image.freepik.com/free-vector/abstract-cross-logo_23-2147536124.jpg",
  //   imgTitle: "Slider Image title",
  //   redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  // },
  // {
  //   id: "xxxxjsdsd",
  //   imgUrl:
  //     "https://image.freepik.com/free-vector/abstract-cross-logo_23-2147536124.jpg",
  //   imgTitle: "Slider Image title",
  //   redirectUrl: "https://localhost:3000/category/protein/workoutsupport/",
  // },
];

export const coupons = [
  {
    couponId: "930c97f8742b9b881f4ee505f7f59bb2",
    couponName: "NEWYEAR",
    minOrder: 100,
    maxDiscount: 20,
    discountPercentage: 50,
    reusable: "Yes",
    expiryDate: "2020-11-15",
  },
  {
    couponId: "c97f8742b9b881f4ee50aabsd669bb2",
    couponName: "HAPPYDIWALI",
    minOrder: 200,
    maxDiscount: 100,
    discountPercentage: 5,
    reusable: "No",
    expiryDate: "2020-11-26",
  },
  {
    couponId: "q23c97f8742b9b881f4ee505f7f59bb2",
    couponName: "MERRYCHRISTMAS",
    chargePrice: 449,
    minOrder: 300,
    maxDiscount: 200,
    discountPercentage: 30,
    reusable: "Yes",
    expiryDate: "2020-12-31",
  },
];
